import { web } from "../middleware";

export const TribePostApi = {
  updatePost: (formData, postId) =>
    web(
      {
        url: `/user/update-post/${postId}`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      formData,
    ),

  getTribeGroups: (params) =>
    web({
      url: "/user/tribe-group",
      method: "GET",
      params: params,
    }),

  createMultiGroupPost: (formData) =>
    web(
      {
        url: "/user/create-multi-group-post",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      formData,
    ),

  // Action endpoints
  likePost: (postId) =>
    web({
      url: `/user/post/like`,
      method: "POST",
      params: { id: postId },
    }),

  toggleSavePost: (postId) =>
    web({
      url: `/user/post/save`,
      method: "POST",
      params: { id: postId },
    }),

  getPostComments: (postId, { page = 1, per_page = 10 } = {}) =>
    web({
      url: `/user/post/comments`,
      method: "GET",
      params: { post_id: postId, page, per_page },
    }),

  getPostDetails: (postId) =>
    web({
      url: `/user/post-details/${postId}`,
      method: "GET",
    }),

  batchTrackViews: (views) =>
    web(
      {
        url: `/user/v3/views/batch`,
        method: "POST",
      },
      { views },
    ),
  // Reactions endpoints
  getReactions: () =>
    web({
      url: `/user/reactions`,
      method: "GET",
    }),

  reactToPost: (payload) =>
    web(
      {
        url: `/user/post/like`,
        method: "POST",
      },
      payload,
    ),

  reactToComment: (payload) =>
    web(
      {
        url: `/user/comment/like`,
        method: "POST",
      },
      payload,
    ),

  togglePinPost: (data) =>
    web({
      url: `/user/pin-post`,
      method: "POST",
      data: data,
    }),

  getUserPosts: ({ page, user_id }) => {
    const config = {
      url: `/v3/posts/user-posts`,
      method: "GET",
      // Initialize params with 'page'
      params: { page },
    };

    // Add user_id to the query parameters if it exists
    if (user_id) {
      // Use the spread operator to add user_id to the existing 'params' object
      config.params = { ...config.params, user_id };
    }

    // The request sent will now be like: /v3/posts/user-posts?page=1&user_id=123
    return web(config);
  },

  getScheduledPosts: ({ group_id, page, per_page } = {}) =>
    web({
      url: `/user/tribe/schedule`,
      method: "GET",
      params: {
        ...(typeof page === "number" ? { page } : {}),
        ...(typeof per_page === "number" ? { per_page } : {}),
        ...(group_id ? { group_id } : {}),
      },
    }),
};
